// Styles
import { atQuery } from '../../scripts/components/mediaQueries';
import './template-product.scss';
import { headerHeight } from '../../scripts/helpers';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateProduct = (context) => {
  const templateProductSection = context.closest('.shopify-section');
  if (!templateProductSection) return;

  const productsGalleries = templateProductSection.querySelectorAll('.product-gallery--carousel');
  productsGalleries.forEach(productsGallery => {

    new Swiper(productsGallery.querySelector('.product-gallery__container'), {
      loop: false,
      direction: 'vertical',
      autoHeight: true,
      pagination: {
        el: productsGallery.querySelector('.product-gallery__pagination'),
        type: productsGallery.dataset.paginationType,
        clickable: true
      },
      navigation: {
        prevEl: productsGallery.querySelector('.product-gallery__arrow--left'),
        nextEl: productsGallery.querySelector('.product-gallery__arrow--right')
      },
      breakpoints: {
        1025: {
          allowSlidePrev: true,
          allowSlideNext: true
        }
      }
    });
  });

  const productMeta = templateProductSection.querySelector('.product__meta');
  if (productMeta.classList.contains('product__meta--fixed')) {
    const fixedToggle = productMeta.querySelector('.product__meta__fixed-toggle');
    const fixedModeToggle = productMeta.querySelectorAll('.fixed-mode-slide-toggle');
    if (fixedToggle && fixedModeToggle.length > 0) {
      fixedToggle.addEventListener('click', () => {
        productMeta.classList.add('is-animating');
        if (productMeta.classList.contains('open')) {
          $(fixedModeToggle).slideUp(500, function () {
            this.style.display = '';
            productMeta.classList.remove('open');
            productMeta.classList.remove('is-animating');
            document.querySelector('html').style.overflowY = '';
          });
        } else {
          document.querySelector('html').style.overflowY = 'hidden';
          $(fixedModeToggle).slideDown(500, function () {
            this.style.display = '';
            productMeta.classList.add('open');
            productMeta.classList.remove('is-animating');
          });
        }
      });
    }

    atQuery('min', 'lg', () => {
      document.querySelector('html').style.overflowY = '';
      productMeta.classList.remove('open');
      productMeta.classList.remove('is-animating');
    });
  }

  const productForm = templateProductSection.querySelector('.product__form');
  productForm.querySelectorAll('.product__form__option__toggle').forEach(toggle => {
    const fieldset = toggle.closest('fieldset');
    if (!fieldset) return;
    toggle.addEventListener('click', () => {
      if (toggle.getAttribute('checked')) return;
      const checkedLabels = fieldset.querySelectorAll('label[checked]');
      checkedLabels.forEach(label => { label.removeAttribute('checked') });
      toggle.setAttribute('checked', '');
    });
  });

  const colorsAccordion = productForm.querySelector('.product__form__colors-accordion');
  if (colorsAccordion) {
    const accordionHeader = colorsAccordion.querySelector('.product__form__colors-accordion__header');
    const accordionContent = colorsAccordion.querySelector('.product__form__colors-accordion__content');
    if (accordionHeader && accordionContent) {
      var isMoving = false;
      accordionHeader.addEventListener('click', function () {
        if (isMoving) return;
        isMoving = true;
        if (colorsAccordion.getAttribute('open')) {
          $(accordionContent).slideUp(350, function () {
            isMoving = false;
            colorsAccordion.removeAttribute('open');
            this.style.display = '';
          });
        } else {
          $(accordionContent).slideDown(350, function () {
            isMoving = false;
            colorsAccordion.setAttribute('open', 'true');
            this.style.display = '';
          });
        }
      });

      const colorToggles = accordionContent.querySelectorAll('.color-label');
      if (colorToggles.length > 0) {
        colorToggles.forEach(toggle => {
          const colorValue = toggle.closest('.color-label').dataset.colorValue;
          const summaryColor = accordionHeader.querySelector('.color-label');
          if (colorValue && summaryColor) {
            toggle.addEventListener('click', () => {
              summaryColor.innerText = colorValue;
              summaryColor.dataset.colorValue = colorValue;
            });
          }
        });
      }
    }
  }

  const productMetaContainer = templateProductSection.querySelector('.product__meta');
  if (productMetaContainer && $(window).outerWidth() > 1023) {
    productMetaContainer.style.top = `${headerHeight()}px`;
  }

  // ICONS POPUP

  window.dAgency.hideIconsPopUp = () => {
    $('.icon-popup').removeClass('visible');
    $('.icon-popup-overlay').removeClass('visible');
  }

  const $keypointIcons = $('.product__meta__keypoints .icon');

  if ($keypointIcons.length > 0) {
    $keypointIcons.on('click', function () {
      $('.icon-popup', $(this)).addClass('visible');
      $('.icon-popup-overlay').addClass('visible');
    })
  }

  const $iconPopUpOverlay = $('.icon-popup-overlay');
  if ($iconPopUpOverlay.length) {
    $iconPopUpOverlay.on('click', function () {
      window.dAgency.hideIconsPopUp();
    });
  }

  const $iconPopUpClose = $('.icon-popup .icon-popup-close');
  if ($iconPopUpClose.length) {
    $iconPopUpClose.on('click', function (e) {
      $(this).parent().toggleClass('visible');
      $('.icon-popup-overlay').removeClass('visible');
      e.stopPropagation();
    });
  }

  // COMPLETE THE LOOK

  const look_slider = templateProductSection.querySelector('.product__meta__look__carousel');

  if (look_slider) {

    new Swiper(look_slider, {
      slidesPerView: 1.2,
      spaceBetween: 4,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
        snapOnRelease: true
      },
      breakpoints: {
        768: {
          slidesPerView: 2.4,
        }
      }
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
    window.dAgency.initTemplateProduct(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
      window.dAgency.initTemplateProduct(el);
    });
  });
}
